import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody35';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy35 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Company Valuation </h2><h4>for a Middle East Based Real Estate Investment & Development Firm</h4>";

  return (
    <>
        <Helmet>
        <title>Company Valuation for a Middle East Based Real Estate Investment & Development Firm</title>
        <meta property="og:title" content="Company Valuation for a Middle East Based Real Estate Investment & Development Firm" />
        <meta property='og:description' content='Company Valuation for a Middle East Based Real Estate Investment & Development Firm'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy32" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy35 
